let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("11tIB"), load("7J7Dl"), load("ffEVr"), load("cWvhX")]).then(() => parcelRequire('8M3ga'));